"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutFilterSchema = exports.UpdatePayoutSchema = exports.CreatePayoutSchema = exports.PayoutType = exports.validNextStates = exports.PayoutState = void 0;
const zod_1 = require("zod");
const __1 = require("../..");
const validation_1 = require("../../util/validation");
var PayoutState;
(function (PayoutState) {
    PayoutState["Created"] = "CREATED";
    PayoutState["Initiated"] = "INITIATED";
    PayoutState["Completed"] = "COMPLETED";
    PayoutState["Failed"] = "FAILED";
    PayoutState["DataUpdated"] = "DATA_UPDATED";
})(PayoutState || (exports.PayoutState = PayoutState = {}));
const validNextStates = (state) => {
    switch (state) {
        case PayoutState.Created: {
            return [
                PayoutState.Initiated,
                PayoutState.DataUpdated,
                PayoutState.Completed,
            ];
        }
        case PayoutState.Initiated: {
            return [PayoutState.Completed, PayoutState.Failed];
        }
        case PayoutState.Completed: {
            return [];
        }
        case PayoutState.Failed: {
            return [PayoutState.DataUpdated];
        }
        case PayoutState.DataUpdated: {
            return [
                PayoutState.Initiated,
                PayoutState.DataUpdated,
                PayoutState.Completed,
            ];
        }
    }
};
exports.validNextStates = validNextStates;
var PayoutType;
(function (PayoutType) {
    PayoutType["Overpayment"] = "OVERPAYMENT";
    PayoutType["CreditorReceivables"] = "CREDITOR_RECEIVABLES";
    PayoutType["CourtFee"] = "COURT_FEE";
})(PayoutType || (exports.PayoutType = PayoutType = {}));
exports.CreatePayoutSchema = zod_1.z.object({
    type: zod_1.z.nativeEnum(PayoutType),
    referenceType: zod_1.z.nativeEnum(__1.Entity),
    referenceId: zod_1.z.string().uuid(),
    account: __1.BankAccountZodSchema,
    recipientText: zod_1.z.string(),
    amount: zod_1.z.number().int(),
    currency: zod_1.z.nativeEnum(__1.Currency),
    state: zod_1.z.nativeEnum(PayoutState),
    details: zod_1.z.any().optional(),
});
exports.UpdatePayoutSchema = zod_1.z.union([
    zod_1.z.object({
        state: zod_1.z.nativeEnum(PayoutState),
    }),
    zod_1.z.object({
        account: __1.BankAccountZodSchema.optional(),
    }),
]);
exports.PayoutFilterSchema = zod_1.z.object({
    fromCreatedAt: zod_1.z.string().datetime().optional(),
    toCreatedAt: zod_1.z.string().datetime().optional(),
    fromUpdatedAt: zod_1.z.string().datetime().optional(),
    toUpdatedAt: zod_1.z.string().datetime().optional(),
    fromAmount: zod_1.z.coerce.number().int().optional(),
    toAmount: zod_1.z.coerce.number().int().optional(),
    types: (0, validation_1.queryJSONSchema)(zod_1.z.array(zod_1.z.nativeEnum(PayoutType)), `types need to be a valid list of types (${Object.values(PayoutType)})`).optional(),
    states: (0, validation_1.queryJSONSchema)(zod_1.z.array(zod_1.z.nativeEnum(PayoutState)), `states need to be a valid list of states (${Object.values(PayoutState)})`).optional(),
    sortKey: zod_1.z
        .enum([
        'type',
        'recipientText',
        'state',
        'amount',
        'currency',
        'updatedAt',
        'createdAt',
    ])
        .optional(),
    sortDirection: zod_1.z.enum(['ASC', 'DESC']).optional(),
});
//# sourceMappingURL=index.js.map